module.exports = fox._r("images/amc-logo.png", __webpack_public_path__ + "_/_/_/common/frame/images/amc-logo.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/amc-logo.png
// module id = 122
// module chunks = 2